// src/components/AboutUs.jsx
import { Globe3D } from "./ui/3d-globe";

const zentraLogo = "/img/logotipo-original.svg";

const zentraMarkers = [
  {
    lat: -29.9027,
    lng: -71.2519,
    src: zentraLogo,
    label: "La Serena",
  },
  {
    lat: -33.4489,
    lng: -70.6693,
    src: zentraLogo,
    label: "Santiago",
  },
  {
    lat: 19.4326,
    lng: -99.1332,
    src: zentraLogo,
    label: "Ciudad de México",
  },
  {
    lat: 40.7128,
    lng: -74.006,
    src: zentraLogo,
    label: "New York",
  },
  {
    lat: 21.3069,
    lng: -157.8583,
    src: zentraLogo,
    label: "Honolulu",
  },
  {
    lat: -34.6037,
    lng: -58.3816,
    src: zentraLogo,
    label: "Buenos Aires",
  },
  {
    lat: -23.5505,
    lng: -46.6333,
    src: zentraLogo,
    label: "São Paulo",
  },
  {
    lat: 40.4168,
    lng: -3.7038,
    src: zentraLogo,
    label: "Madrid",
  },
  {
    lat: 51.5074,
    lng: -0.1278,
    src: zentraLogo,
    label: "London",
  },
  {
    lat: -33.9249,
    lng: 18.4241,
    src: zentraLogo,
    label: "Cape Town",
  },
  {
    lat: 25.2048,
    lng: 55.2708,
    src: zentraLogo,
    label: "Dubai",
  },
  {
    lat: 28.6139,
    lng: 77.209,
    src: zentraLogo,
    label: "New Delhi",
  },
  {
    lat: 1.3521,
    lng: 103.8198,
    src: zentraLogo,
    label: "Singapore",
  },
  {
    lat: 35.6762,
    lng: 139.6503,
    src: zentraLogo,
    label: "Tokyo",
  },
  {
    lat: -33.8688,
    lng: 151.2093,
    src: zentraLogo,
    label: "Sydney",
  },
  {
    lat: -41.2865,
    lng: 174.7762,
    src: zentraLogo,
    label: "Wellington",
  },
];

export default function AboutUs() {
  return (
    <section id="nosotros" className="relative py-16">
      <div
        className="pointer-events-none absolute inset-0 -z-10"
        style={{
          background: `
            radial-gradient(1200px 520px at 8% -10%, rgba(32,75,151,.10), transparent 65%),
            radial-gradient(1400px 600px at 100% -10%, rgba(93,131,243,.13), transparent 70%),
            radial-gradient(1200px 520px at 50% 110%, rgba(15,23,42,.07), transparent 70%)
          `,
        }}
      />

      <div className="mx-auto max-w-6xl px-4">
        <div className="relative overflow-hidden rounded-3xl bg-white shadow-[0_24px_70px_rgba(15,23,42,0.12)] ring-1 ring-black/5">
          <div className="grid items-center gap-10 p-6 md:grid-cols-2 md:p-10 lg:p-12">
            {/* GLOBO */}
            <div className="order-2 md:order-1">
              <div className="relative h-[390px] overflow-hidden rounded-[32px] bg-[#05070d] shadow-[0_24px_70px_rgba(15,23,42,0.24)] ring-1 ring-white/10 md:h-[460px]">
                <div className="absolute inset-0 bg-[radial-gradient(circle_at_25%_15%,rgba(93,131,243,.24),transparent_34%),radial-gradient(circle_at_90%_90%,rgba(32,75,151,.28),transparent_38%),linear-gradient(135deg,#05070d_0%,#0f172a_55%,#07111f_100%)]" />

                <div className="absolute left-5 top-5 z-20 rounded-full border border-white/10 bg-white/10 px-4 py-2 text-xs font-semibold uppercase tracking-[0.22em] text-white/75 backdrop-blur">
                  Zentra Network
                </div>

                <div className="absolute bottom-5 left-5 z-20 max-w-[260px]">
                  <h3 className="text-2xl font-bold tracking-tight text-white">
                    Tecnología conectada
                  </h3>
                  <p className="mt-2 text-sm leading-6 text-white/65">
                    Sistemas, POS y GPS pensados para operar con información en
                    tiempo real.
                  </p>
                </div>

                <div className="pointer-events-none absolute -left-24 top-20 h-72 w-72 rounded-full bg-[#204b97]/20 blur-3xl" />
                <div className="pointer-events-none absolute -right-28 bottom-0 h-80 w-80 rounded-full bg-[#5d83f3]/20 blur-3xl" />

                <div className="pointer-events-none absolute -bottom-44 -right-56 z-10 h-[650px] w-[650px] md:-bottom-48 md:-right-64 md:h-[720px] md:w-[720px]">
                  <Globe3D
                    className="h-full w-full"
                    markers={zentraMarkers}
                    config={{
                      atmosphereColor: "#5d83f3",
                      atmosphereIntensity: 0.7,
                      atmosphereBlur: 2.4,
                      bumpScale: 4,
                      autoRotateSpeed: 0.45,
                      ambientIntensity: 0.72,
                      pointLightIntensity: 1.7,
                      showAtmosphere: true,
                      enableZoom: false,
                      enablePan: false,
                    }}
                  />
                </div>
              </div>
            </div>

            {/* TEXTO */}
            <div className="order-1 md:order-2">
              <span className="inline-flex items-center gap-2 rounded-full border border-black/10 bg-white/70 px-3 py-1 text-sm text-slate-700 backdrop-blur">
                Nosotros
                <span
                  className="h-2 w-2 rounded-full"
                  style={{ background: "#5d83f3" }}
                />
              </span>

              <h2 className="heading-display mt-4 text-4xl font-bold text-slate-900 md:text-5xl">
                Sobre nosotros
              </h2>

              <p className="mt-3 max-w-xl text-slate-600">
                En Zentra Group unimos el{" "}
                <strong>desarrollo de sistemas web a medida</strong>, la{" "}
                <strong>gestión inteligente de flotas en tiempo real</strong> y
                soluciones <strong>POS para negocios</strong>. A través de{" "}
                <strong>Zentra Sistemas</strong>, <strong>Zentra GPS</strong> y{" "}
                <strong>Zentra POS</strong> ayudamos a las empresas a digitalizar
                procesos, controlar su operación y tomar mejores decisiones con
                datos reales.
              </p>

              <ul className="mt-6 grid gap-3 text-slate-700">
                <li className="flex gap-3">
                  <span
                    className="mt-2 h-2 w-2 rounded-full"
                    style={{ background: "#204b97" }}
                  />
                  Desarrollo de sistemas web y automatizaciones.
                </li>

                <li className="flex gap-3">
                  <span
                    className="mt-2 h-2 w-2 rounded-full"
                    style={{ background: "#204b97" }}
                  />
                  Integraciones con ERPs, CRMs, pagos, APIs y servicios externos.
                </li>

                <li className="flex gap-3">
                  <span
                    className="mt-2 h-2 w-2 rounded-full"
                    style={{ background: "#204b97" }}
                  />
                  Monitoreo de flotas en tiempo real con Zentra GPS.
                </li>

                <li className="flex gap-3">
                  <span
                    className="mt-2 h-2 w-2 rounded-full"
                    style={{ background: "#204b97" }}
                  />
                  POS para ventas, boletas, facturación, inventario y reportes.
                </li>

                <li className="flex gap-3">
                  <span
                    className="mt-2 h-2 w-2 rounded-full"
                    style={{ background: "#204b97" }}
                  />
                  Acompañamiento, soporte y mejora continua.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}